import * as React from 'react';
import { Box } from '@mui/material';
import { GridToolbar, GridToolbarContainer } from '@mui/x-data-grid-pro';
import type { GridToolbarExport } from '@mui/x-data-grid-pro';

import CustomExport from './CustomExport';

type GridToolbarProps = React.ComponentProps<typeof GridToolbar>;
type ExportProps = React.ComponentProps<typeof GridToolbarExport>;

type Props = GridToolbarProps & {
  children?: React.ReactNode;
  exportExtraItems?: React.ReactNode;
  csvOptions?: ExportProps['csvOptions'];
  printOptions?: ExportProps['printOptions'];
};

export default function BaseToolbar({
  children,
  exportExtraItems,
  csvOptions,
  printOptions,
  ...toolbarProps
}: Props) {
  return (
    <div className="tpn-grid-toolbar-scope">
      {exportExtraItems ? (
        <style>
          {`
            .tpn-grid-toolbar-scope .MuiDataGrid-toolbarContainer > .MuiButtonBase-root[aria-label="Export"] {
              display: none !important;
            }
          `}
        </style>
      ) : null}

      <GridToolbarContainer>
        <GridToolbar {...toolbarProps} />

        {exportExtraItems ? (
          <CustomExport
            csvOptions={csvOptions}
            printOptions={printOptions}
            exportExtraItems={exportExtraItems}
          />
        ) : null}
        {/* GridToolbar renders its own nested GridToolbarContainer around the built-in
            buttons, which adds an extra theme.spacing(0.5) top padding on top of this
            outer container's own padding. Without matching it here, custom children sit
            a couple pixels higher than the built-in buttons once this row's align-items:
            center centers both against the taller nested block. display/alignItems/flexWrap
            here just re-establish what these children got for free as direct flex items of
            GridToolbarContainer (some callers, e.g. RemediationVerificationAdminPanel, pass
            multiple sibling buttons expecting a horizontal row, not a block-stacked column).
            flexGrow: 1 keeps this wrapper stretched to the row's remaining width so a nested
            `ml: 'auto'` (PoliciesAdminPanel et al., to right-align an Add button) still has
            free space to push into - without it, this wrapper would hug its own content and
            leave nothing for `ml: auto` to consume. */}
        {children ? (
          <Box sx={{ pt: 0.5, display: 'flex', alignItems: 'center', flexWrap: 'wrap', flexGrow: 1 }}>
            {children}
          </Box>
        ) : null}
      </GridToolbarContainer>
    </div>
  );
}
